import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import * as analytics from '../lib/analytics';

/**
 * Custom hook for tracking analytics events
 * - Automatically tracks page views
 * - Provides function for tracking custom events
 * 
 * @returns Object with trackEvent function
 */
export function useAnalytics() {
  const location = useLocation();

  // Track page views automatically when location changes
  useEffect(() => {
    analytics.pageview(location.pathname + location.search);
  }, [location]);

  // Memoize the event tracking function to maintain reference equality
  const trackEvent = useCallback(analytics.event, []);

  return { trackEvent };
} 